<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Bodegas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      repit: true,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "bodegas/get",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      estado_tipo: false,
      formDepa: {
        nombre: "",
        descripcion: "",
        tiendaid: "",
        estante: "",
        estantes: [],
        state: true,
        id: 0,
      },

      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Bodegas",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Bodegas",
          active: true,
        },
      ],
      fields: [
        {
          name: "nombre_bodega",
          title: "Nombre",
          sortField: "nombre_bodega",
          width: "20%",
        },
        {
          name: "descripcion_bodega",
          title: "Descripción",
          sortField: "descripcion_bodega",
          width: "30%",
        },
        {
          name: "tienda.nombre_tienda",
          title: "Tienda",
          sortField: "tienda.nombre_tienda",
          width: "30%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_bodega",
      sortDesc: false,
      searchLabel: { nombre: "Nombre", value: "nombre" },
      filterLabel: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formDepa: {
      nombre: {
        required,
        async isUnique(value) {
          if (value === "") return true;

          const usuario = this.$store.state.authfack.user;
          let response = await axios
            .get(
              this.apiUrl +
                "bodegas/nombre_repetido?nombre=" +
                value +
                "&id=" +
                this.formDepa.id +
                "&tienda=" +
                this.formDepa.tiendaid.id,
              {
                headers: { "x-token": usuario.token },
              }
            )
            .catch(console.log);
          this.repit = response.data.msg;
          // console.log(response.data.msg);
          return response.data.msg;
        },
      },
      descripcion: { required },
      tiendaid: { required },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    eliminarEstante(index) {
      let me = this;
      me.formDepa.estantes.splice(index, 1);
    },
    agregarEstante() {
      this.$v.$touch();
      if (this.formDepa.estante != "") {
        this.formDepa.estantes.push({
          nombre: this.formDepa.estante,
        });
        this.formDepa.estante = "";
      }
    },
    //Tiendas para llegar el v-select
    getTiendas() {
      let me = this;
      me.tiendasData = [];

      const usuario = this.$store.state.authfack.user;
      axios
        .get(process.env.VUE_APP_URL + "tiendas/busqueda", {
          headers: { "x-token": usuario.token },
        })
        .then(function(response) {
          me.tiendasData = response.data.data;
          // console.log(me.tiendasData)
        })
        .catch(function(error) {
          console.log(error);
          this.showModalL = false;
        });
        // .finally(() => {
        //   if (estado === "new-item") {
        //     me.formDepa.tiendaid = me?.tiendasData[0];
        //     console.log( me.formDepa.tiendaid );
        //   }
        //   this.showModalL = false;
        // });
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid

      this.$v.$touch();
      if (this.$v.$invalid || this.repit == false) {
        // console.log(this.$v.$invalid, this.repit)
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          // console.log('esta llegando aca ')
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },

    //Desactivar registro
    desactivate() {
      const { id, nombre } = this.formDepa;
      const usuario = this.$store.state.authfack.user;

      axios
        .put(
          process.env.VUE_APP_URL + "bodegas/desactivate",
          {
            id: id,
          },
          {
            headers: { "x-token": usuario.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " Desactivado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formDepa;
      const usuario = this.$store.state.authfack.user;

      axios
        .put(
          process.env.VUE_APP_URL + "bodegas/activate",
          {
            id: id,
          },
          {
            headers: { "x-token": usuario.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    //Guardar registro
    save() {
      const usuario = this.$store.state.authfack.user;

      const { nombre, descripcion, tiendaid, estantes } = this.formDepa;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "bodegas/store",
          {
            nombre: nombre,
            descripcion: descripcion,
            tienda: tiendaid.id,
            estado_tipo: this.estado_tipo,
            detalles: estantes,
          },
          {
            headers: { "x-token": usuario.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          me.$refs.vuetable.refresh();
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const { nombre, descripcion, id, tiendaid } = this.formDepa;
      const me = this;
      const usuario = this.$store.state.authfack.user;
      axios
        .put(
          process.env.VUE_APP_URL + "bodegas/update",
          {
            id: id,
            nombre: nombre,
            descripcion: descripcion,
            tienda: tiendaid.id,
          },
          {
            headers: { "x-token": usuario.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Actualizado", this.options);
          me.$refs.vuetable.refresh();
          this.showModalE = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formDepa.id = 0;
      this.formDepa.descripcion = "";
      this.formDepa.nombre = "";
      this.formDepa.descripcion = "";
      this.formDepa.tiendaid = null;
      this.formDepa.estantes = [];
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "edit-item") {
        console.log('esta entrando')
        this.getTiendas("edit-item");
        this.formDepa.nombre = data.nombre_bodega;
        this.formDepa.descripcion = data.descripcion_bodega;
        this.formDepa.tiendaid = data.tienda;
        this.formDepa.id = data.id;
        this.showModalE = true;
      }
      if (action == "new-item") {
        this.getTiendas("new-item");
        this.formDepa.id = 0;
        // console.log(this.tiendasData);
        this.formDepa.descripcion = "";
        this.formDepa.nombre = "";
        this.formDepa.descripcion = "";
        
      }
      if (action == "desactivate-item") {
        this.formDepa.nombre = data.nombre_bodega;
        this.formDepa.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formDepa.nombre = data.nombre_bodega;
        this.formDepa.id = data.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar Ubicación"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea Activar la Ubicación {{ this.formDepa.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea Desactivar la Ubicación {{ this.formDepa.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
          centered
          ref="modalUpdate"
          id="modalUpdate"
          title="Editar Ubicación"
          no-close-on-backdrop
          v-model="showModalE"
          @hidden="closeModal('update')"
          @show="openModal('uptade')"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label>Sucursal</label>
                  <v-select
                    
                    v-model.trim="$v.formDepa.tiendaid.$model"
                    :state="!$v.formDepa.tiendaid.$error"
                    :options="tiendasData"
                    label="nombre_tienda"
                  ></v-select>
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formDepa.tiendaid.$error &&
                        !$v.formDepa.tiendaid.required,
                    }"
                  >
                    Debe seleccionar una tienda
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Nombre</label>
                  <input
                    id="name"
                    v-model="$v.formDepa.nombre.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un nombre de ubicación"
                    :class="{
                      'is-invalid': $v.formDepa.nombre.$error,
                    }"
                    @input="$v.formDepa.nombre.$touch()"
                  />
                  <div
                    v-if="
                      $v.formDepa.nombre.$error && !$v.formDepa.nombre.required
                    "
                    class="invalid-feedback"
                  >
                    El nombre es obligatorio.
                  </div>
                  <div
                    v-if="!$v.formDepa.nombre.isUnique"
                    :class="{
                      'invalid-feedback': !$v.formDepa.nombre.isUnique,
                    }"
                  >
                    El nombre de la Ubicación {{ formDepa.nombre }} ya existen
                    en nuestros registros.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Descripción</label>
                  <input
                    id="phone"
                    v-model.trim="$v.formDepa.descripcion.$model"
                    :state="!$v.formDepa.descripcion.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una Descripción"
                  />
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('update')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <b-modal
          centered
          @show="openModal('save')"
          @hidden="openModal('save')"
          v-model="showModalN"
          id="modalSave"
          ref="modalSave"
          title="Nueva Ubicación"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label>Sucursal</label>
                  <v-select
                    
                    v-model.trim="formDepa.tiendaid"
                    :state="!$v.formDepa.tiendaid.$error"
                    :options="tiendasData"
                    label="nombre_tienda"
                  ></v-select>
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formDepa.tiendaid.$error &&
                        !$v.formDepa.tiendaid.required,
                    }"
                  >
                    Debe seleccionar una sucursal
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Nombre</label>
                  <input
                    id="name"
                    v-model="$v.formDepa.nombre.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un nombre"
                    :class="{
                      'is-invalid': $v.formDepa.nombre.$error,
                    }"
                    @input="$v.formDepa.nombre.$touch()"
                  />
                  <div
                    v-if="
                      $v.formDepa.nombre.$error && !$v.formDepa.nombre.required
                    "
                    class="invalid-feedback"
                  >
                    El nombre es obligatorio.
                  </div>
                  <div
                    v-if="!$v.formDepa.nombre.isUnique"
                    :class="{
                      'invalid-feedback': !$v.formDepa.nombre.isUnique,
                    }"
                  >
                    El nombre de la Ubicación {{ formDepa.nombre }} ya existen
                    en nuestros registros.
                  </div>
                </div>
              </div>
              
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Descripción</label>
                  <input
                    id="phone"
                    v-model.trim="$v.formDepa.descripcion.$model"
                    :state="!$v.formDepa.descripcion.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una Descripción"
                  />
                </div>
              </div>
             
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('save')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Ubicaciones</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="changeTypeSearch(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                      v-b-modal.modalSave
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nueva Ubicación
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :http-options="httpOptions"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
              <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado_bodega"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado_bodega == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado_bodega == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado_bodega == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_bodega == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
